/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: <  Ravi Ranjan Kumar, Mylavarapu Sarath Sai, Ujjwal Singh >

*/

import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import { Grid, TextField, Typography, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

//core components
// import TabsLists from './add-patient-tabs-setting'
const useStyles = makeStyles((theme) => ({
 textField: {
  margin: "10px",
 },
 textFieldAnother: {
  background: "#fff",
 },
 titleText: {
  background: theme.palette.action.active,
  color: "#fff",
  fontSize: "18px",
  textAlign: "center",
 },
 textContent: {
  background: "#fff",
  color: "#263238",
  fontSize: "18px",
  textAlign: "left",
 },
 titleFont: {
  color: "#fff",
  fontSize: "18px",
 },
}));
export default function ConfirmationDialogRaw(props) {
 const { onClose, value: valueProp, open, ...other } = props;
 const radioGroupRef = React.useRef(null);
 const classes = useStyles();
 const handleEntering = () => {
  if (radioGroupRef.current != null) {
   radioGroupRef.current.focus();
  }
 };

 const handleCancel = () => {
  props.handleCloseModel();
 };

 const handleSave = () => {
  // alert()
  props.handleSaveChanges();
 };
 return (
  <Dialog
   maxWidth="xs"
   fullWidth
   onEntering={handleEntering}
   aria-labelledby="confirmation-dialog-title"
   open={props.isOpenModel}
   onClose={handleCancel}
   {...other}
  >
   <DialogTitle id="confirmation-dialog-title" className={classes.titleText}>
    <Typography variant="h4" className={classes.titleFont}>
     {props.title}
    </Typography>
   </DialogTitle>
   <DialogContent dividers className={classes.textContent}>
    <Typography variant="h5">{props.msg}</Typography>
   </DialogContent>
   <DialogActions>
    <Button onClick={handleSave} variant="outlined" color="secondary">
     Yes
    </Button>
    <Button
     autoFocus
     onClick={handleCancel}
     variant="outlined"
     color="secondary"
    >
     No
    </Button>
   </DialogActions>
  </Dialog>
 );
}

ConfirmationDialogRaw.propTypes = {
 onClose: PropTypes.func.isRequired,
 open: PropTypes.bool.isRequired,
 value: PropTypes.string.isRequired,
};
